import {WalletLoadingSpinner} from "./WalletLoadingSpinner";
import {MerchantLoadingSpinner} from "./MerchantLoadingSpinner";
import {WALLET_LOADING_SPINNER_DURATION} from "../WidgetConstants";


export class LoadingWidget {
    static ANIMATION_DURATION = WALLET_LOADING_SPINNER_DURATION;

    static walletLoad(backendCall) {
        return this.load(WalletLoadingSpinner, backendCall);
    }

    static async merchantLoad(backendCall) {
        return this.load(MerchantLoadingSpinner, backendCall);
    }

    static async load(loadingSpinnerClass, backendCall) {
        const start = performance.now();
        loadingSpinnerClass.show();

        return new Promise(async (resolve, reject) => {
            let apiRequestError = null;
            let response = null;

            try {
                response = await backendCall();
            } catch (e) {
                apiRequestError = e;
            }
            const end = performance.now();
            const promiseCallbackFunc = apiRequestError ? reject : resolve;
            const promiseCallbackArg = apiRequestError ? apiRequestError : response;

            if (end - start < this.ANIMATION_DURATION) {
                setTimeout(() => {
                    loadingSpinnerClass.hide();
                    promiseCallbackFunc(promiseCallbackArg);
                }, this.ANIMATION_DURATION - (end - start));
            } else {
                loadingSpinnerClass.hide();
                promiseCallbackFunc(promiseCallbackArg);
            }
        });
    }
}
